// SafetyCrossPage — standalone route (/app/safety-cross). Thin wrapper around
// the reusable SafetyCrossView (monthly + annual). Supports ?client / ?building
// pre-selection and a ?back deep-link (from the Compliance Hub / projects).
import { useSearchParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SafetyCrossView from "@/pages/safety/metrics/SafetyCrossView";

export default function SafetyCrossPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const backUrl = searchParams.get("back");
    const qpClient = searchParams.get("client") || undefined;
    const qpBuilding = searchParams.get("building") || undefined;

    return (
        <div data-testid="safety-cross-page" className="space-y-5">
            {backUrl && (
                <button data-testid="safety-cross-back" onClick={() => navigate(backUrl)}
                    className="inline-flex items-center gap-1.5 text-[13px] font-semibold" style={{ color: "var(--brand-accent, #C75A1B)" }}>
                    <ArrowLeft size={15} /> Back to project
                </button>
            )}
            <div>
                <span className="inline-block pb-1 text-[10.5px] font-bold tracking-[.08em] uppercase"
                    style={{ borderBottom: "2px solid var(--brand-accent, #C75A1B)", color: "#6F6A64" }}>
                    Safety &amp; Compliance
                </span>
                <h2 className="text-2xl font-bold tracking-tight mt-2 text-[#1F1F1F]">Safety Cross</h2>
                <p className="text-[13px] mt-1" style={{ color: "#6F6A64" }}>
                    Monthly &amp; annual incident scorecard — colour per day reflects the worst event recorded.
                </p>
            </div>
            <SafetyCrossView initialClientId={qpClient} initialBuildingId={qpBuilding} />
        </div>
    );
}
